import * as React from 'react';
import SelectableCreditCardListContainer from './selectable_credit_card_list_container';
import CheckoutBillingAddressForm, { ICheckoutBillingAddressProps } from './checkout_billing_address_form';

const CheckoutCreditCardSelectionForm: React.StatelessComponent<ICheckoutBillingAddressProps> = (props) => {
  const billingAddressForm = <CheckoutBillingAddressForm {...props} />;
  return (
    <SelectableCreditCardListContainer
      checkoutBillingAddressForm={billingAddressForm}
      belowCreditCardThreshold={props.belowCreditCardThreshold}
    />
  );
};

export default CheckoutCreditCardSelectionForm;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/checkout_credit_card_selection_form.tsx